import { useEffect } from 'react';
import { detectTenantId, getActiveTenantProfile, isMercuryTenant } from '../utils/tenantBranding';

export { isMercuryTenant };

function upsertLink(rel: string, attrs: Record<string, string>) {
  const selector = `link[rel="${rel}"][data-tenant-head="true"]`;
  let el = document.querySelector<HTMLLinkElement>(selector);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    el.setAttribute('data-tenant-head', 'true');
    document.head.appendChild(el);
  }
  if (attrs.href) el.href = attrs.href;
  if (attrs.type) el.type = attrs.type;
  Object.entries(attrs).forEach(([k, v]) => {
    if (k !== 'href' && k !== 'type') el!.setAttribute(k, v);
  });
}

/**
 * Keeps document title, favicon, apple-touch-icon, manifest, and meta in sync with the active tenant.
 */
const TenantBrandingHead: React.FC = () => {
  const apply = () => {
    const profile = getActiveTenantProfile();
    const iconHref = profile.logoMark;
    const iconType = iconHref.endsWith('.svg') ? 'image/svg+xml' : 'image/png';
    const manifestHref = '/manifest.json';

    document.title = profile.companyName;

    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
      themeMeta.setAttribute('content', profile.themeColors.primary);
    }

    const descMeta = document.querySelector('meta[name="description"]');
    if (descMeta) {
      descMeta.setAttribute('content', profile.companyTagline);
    }

    upsertLink('icon', { href: iconHref, type: iconType });
    upsertLink('shortcut icon', { href: iconHref, type: iconType });
    upsertLink('apple-touch-icon', { href: iconHref });

    const manifestEl = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (manifestEl) {
      manifestEl.href = manifestHref;
    }

    document.querySelectorAll('link[rel="icon"]:not([data-tenant-head])').forEach((node) => {
      if (node.id === 'legacy-favicon-png') node.remove();
    });
  };

  useEffect(() => {
    apply();
    window.addEventListener('tenantBrandingLoaded', apply);
    return () => window.removeEventListener('tenantBrandingLoaded', apply);
  }, []);

  return null;
};

export default TenantBrandingHead;
